<script lang="ts">
	import { goto } from '$app/navigation';
	import type { QueueTask } from '@enzianweb/shared';
	import { dismissQueueTask, getQueueTask, Icon, queueTaskEventBus } from '@enzianweb/shared';
	import { onDestroy, onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { fade } from 'svelte/transition';
	
	interface Props {
		queueTask: QueueTask;
	}

	let { queueTask = $bindable() }: Props = $props();

	let maxQueryTime: number = 5;
	let hideFinishedTaskAfterMillis: number = 4000;
	let timeoutTask: NodeJS.Timeout;

	/**
	 * Get the state of the given queue task
	 * @param id
	 */
	async function checkQueueTaskState(id: number, queryCount: number) {
		//Query the task
		queueTask = await getQueueTask(id);

		if (queryCount > maxQueryTime && timeoutTask) {
			//remove the timer
			clearTimeout(timeoutTask);
			//Remove the queue task from the ui
			dismissQueueTask(queueTask);
			return;
		}

		if (queueTask.success != null || queueTask.success != undefined) {
			//Push message to the queue event bus
			$queueTaskEventBus = queueTask;

			//Remove the task after it was finished
			setTimeout(() => {
				dismissQueueTask(queueTask);
			}, hideFinishedTaskAfterMillis);

			//Remove the message again
			$queueTaskEventBus = null;
		} else {
			timeoutTask = setTimeout(
				() => checkQueueTaskState(queueTask.id, queryCount + 1),
				2000 * queryCount
			);
		}
	}

	onMount(() => {
		//Create a timeout to query if the queue task is still running
		timeoutTask = setTimeout(() => checkQueueTaskState(queueTask.id, 1), 3000);
	});

	onDestroy(() => {
		if (timeoutTask) {
			clearTimeout(timeoutTask);
		}
	});
</script>

<button
	onclick={() => {
		//Move the user to the queue tasks
		goto('/queue-tasks');
	}}
	class="bg-white dark:bg-dark-400 shadow-lg pointer-events-auto"
	transition:fade
>
	<div class="flex">
		<div
			class="text-white icon flex items-center px-2"
			class:bg-green={queueTask.success}
			class:bg-yellow={queueTask.success == null}
			class:bg-red={queueTask.success == false}
		>
			<Icon size="big" name="bars-progress" classInfo="fill-white"></Icon>
		</div>

		<div class="mx-4 py-2">
			<p class="font-bold">
				{$_('queuetaskview.lbl_work_in_progress')}
			</p>
			<p class="">{queueTask.name}</p>
		</div>
	</div>
</button>
